/**
 * Build-time feature flags.
 *
 * Create React App only exposes env vars prefixed with `REACT_APP_` to the
 * client bundle (this is NOT a Next.js app — `NEXT_PUBLIC_*` would be
 * undefined here). `REACT_APP_FEATURE_TECH_CARD_V2=true` is set in both `.env`
 * and `.env.production`: the v2 TechnicianCard is the dashboard staff use, and
 * the Credentials button and the Print section exist only on it.
 */
export const FEATURE_TECH_CARD_V2 =
  process.env.REACT_APP_FEATURE_TECH_CARD_V2 === 'true';

/**
 * New Ticket / Edit Ticket page layout. OFF (default) = the current
 * three-column grid. ON = the responsive "Customer rail + main column" layout
 * (mobile-first / phone-ready). Set `REACT_APP_FEATURE_TICKET_LAYOUT_V2=true`
 * in the staging `.env` to evaluate; the legacy layout stays the shipped
 * default until sign-off.
 */
export const FEATURE_TICKET_LAYOUT_V2 =
  process.env.REACT_APP_FEATURE_TICKET_LAYOUT_V2 === 'true';
